
import { heIL } from "@mui/material/locale";

export const hebrewGridLocale = {
    ...heIL,
    localeText: {
      // Basic grid translations
      noRowsLabel: "אין שורות",
      columnMenuSortAsc: "מיין לפי סדר עולה",
      columnMenuSortDesc: "מיין לפי סדר יורד",
      columnMenuUnsort: "הסר מיון",
      columnMenuFilter: "סנן",
      columnMenuHideColumn: "הסתר עמודה",
      columnMenuShowColumns: "הצג עמודות",
      columnMenuManageColumns: "נהל עמודות",

      // Columns management text
      columnsManagementSearchTitle: "חפש",
      columnsManagementNoColumns: "אין עמודות",
      columnsManagementShowHideAllText: "הצג/הסתר הכל",
      columnsManagementReset: "אתחל",

      // Filter and operator translations
      filterPanelAddFilter: "הוסף מסנן",
      filterPanelDeleteIconLabel: "מחק",
      filterPanelOperators: "אופרטור",
      filterPanelInputLabel: " ",
      filterPanelOperatorAnd: "וגם",
      filterPanelOperatorOr: "או",
      filterPanelColumns: " ",
      filterPanelInputPlaceholder: "ערך סינון",
      filterPanelOperator: " ",

      // Filter options translations
      filterOperatorContains: "מכיל",
      filterOperatorEquals: "שווה ל",
      filterOperatorStartsWith: "מתחיל עם",
      filterOperatorEndsWith: "מסתיים עם",
      filterOperatorIs: 'שווה ל',
      filterOperatorNot: 'אינו שווה ל',
      filterOperatorAfter: 'מתאריך',
      filterOperatorOnOrAfter: 'מתאריך כולל',
      filterOperatorBefore: 'עד תאריך',
      filterOperatorOnOrBefore: 'עד תאריך כולל',
    
      filterOperatorIsEmpty: "ריק",
      filterOperatorIsNotEmpty: "לא ריק",
      filterOperatorIsAnyOf: "אחד מ",

      // Pagination and display translations
      paginationOf: "מתוך",
      MuiTablePagination: {
        labelRowsPerPage: "מספר שורות בעמוד",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} מתוך ${count !== -1 ? count : `יותר מ-${to}`}`,
      },
      // Add more translations as needed
    },
  };